/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';


export interface ContractsControllerDelete$Params {
  tenant: string;
  id: string;
}

export function contractsControllerDelete(http: HttpClient, rootUrl: string, params: ContractsControllerDelete$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<void>> {
  const rb = new SalesRequestBuilder(rootUrl, contractsControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as SalesStrictHttpResponse<void>;
    })
  );
}

contractsControllerDelete.PATH = '/o2-sales/contracts/tenant/{tenant}/{id}';
